export const WORD_LIST: string[] = [
	"ocean",
	"fire",
	"moon",
	"castle",
	"garden",
	"library",
	"compass",
	"thunder",
	"mirror",
	"bridge",
	"forest",
	"clock",
	"candle",
	"river",
	"mountain",
	"star",
	"key",
	"wolf",
	"storm",
	"treasure",
	"paper",
	"glass",
	"sword",
	"diamond",
	"dream",
	"shadow",
	"lantern",
	"fog",
	"honey",
	"crow",
	"anchor",
	"iron",
	"marble",
	"dawn",
	"crystal",
	"cave",
	"desert",
	"feather",
	"coin",
	"flame",
	"vine",
	"frost",
	"thorn",
	"echo",
	"silk",
	"torch",
	"wave",
	"dust",
	"crown",
	"mask",
];
